import React, { Component } from 'react';
import ChartEnhanced from '../../../ChartEnhanced/ChartEnhanced';
import moment from 'moment';

class ChartWithSliderAdapter extends Component {
  constructor(props) {
    super(props);

    this._isQueryDifferentFromState = this._isQueryDifferentFromState.bind(this);
    this._handleNotification = this._handleNotification.bind(this);
  }

  render() {
    let dateTimeFrom = this.props.query[this.props.settings.Configuration.Slider.key[0]];
    let dateTimeTo = this.props.query[this.props.settings.Configuration.Slider.key[1]];
    let maxDate = this.props.settings.Configuration.Slider
      ? this.props.settings.Configuration.Slider.mode.endType == 'month'
        ? moment.utc().add(1, 'months').startOf('month')
        : moment.utc().add(1, 'days').startOf('day')
      : moment.utc().startOf('day');

    return (
      <ChartEnhanced
        config={this.props.settings.Configuration}
        dateTimeFrom={dateTimeFrom}
        dateTimeTo={dateTimeTo}
        onChangeDateTime={this._handleNotification}
        activeTimeGran={this._getNewTimeGran(dateTimeFrom, dateTimeTo)}
        dateTimeError={false}
        maxDateTo={maxDate}
      />
    );
  }

  _getNewTimeGran = (dateFrom, dateTo) => {
    let newTimeGran = null;

    if (moment(dateFrom).isSame(dateTo)) {
      newTimeGran = moment.duration(1, 'minutes');
    } else {
      newTimeGran = moment.duration(moment(dateTo).diff(moment(dateFrom), 'minutes'), 'minutes');
    }

    return newTimeGran;
  };

  _isQueryDifferentFromState = (dateFrom, dateTo) => {
    return (
      moment(dateFrom).format() !=
        this.props.query[this.props.settings.Configuration.Slider.key[0]] ||
      moment(dateTo).format() != this.props.query[this.props.settings.Configuration.Slider.key[1]]
    );
  };

  _handleNotification = (newRange) => {
    if (this._isQueryDifferentFromState(newRange.dateFrom, newRange.dateTo)) {
      let newQuery = {
        [this.props.settings.Configuration.Slider.key[0]]: moment(newRange.dateFrom).format(),
        [this.props.settings.Configuration.Slider.key[1]]: moment(newRange.dateTo).format(),
      };

      if (
        this.props.settings.Configuration.Slider.type == 'TimeRangeRounding' &&
        this.props.settings.Configuration.Slider.key[2] != undefined
      ) {
        //update in query the report
        newQuery = {
          ...newQuery,
          [this.props.settings.Configuration.Slider.key[2]]: newRange.optionValue,
        };
      }

      if (
        this.props.settings.Configuration.Slider.mode &&
        this.props.settings.Configuration.Slider.mode.confirm === 'auto'
      ) {
        newQuery.$reload = true;
      }

      this.props.onQueryChanged(newQuery, this.props.settings);
    }
  };
}

export default ChartWithSliderAdapter;
